"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const getStyles = ({ theme, props }) => ({
    tagContainer: {
        padding: theme.spacing(0, 0.5),
        backgroundColor: props?.backgroundColor ? props?.backgroundColor : theme.palette.grey[200],
        color: props?.fontColor ? props.fontColor : theme.palette.primary[500],
        width: "max-content",
        borderRadius: 1,
    },
    tagText: {
        display: "block",
        fontWeight: props?.fontWeight,
        maxWidth: props?.maxLength + 2 + "ch",
    },
});
/**
 *
 * A component used to display additional information about a entity. Common examples where we would like to use tags are  when displaying flags and priority related to entities such as user, case, event, or asset.
 *
 * @remarks
 *
 * ## Tags vs Chips
 * Chips should always be used when the intent is for the user to interact with the chip and make a change, for example to change the case severity on the Argus for Mobile app, or as filter options on a list.
 * Tags are never interactive, and so should be used to display static information like flags in Case Search, or user info in a watcher list (Default Watcher, Inherited etc).
 *
 * @example ### Basic example
 *
 * This examples shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_Tag.jsx
 * ```
 *
 */
const Tag = ({ size = "medium", backgroundColor, fontColor, text, maxLength = 25, fontWeight = "normal", typographyProps = {}, tooltipProps, }) => {
    const theme = (0, styles_1.useTheme)();
    const styles = getStyles({ theme, props: { backgroundColor, fontColor, maxLength, fontWeight } });
    const { sx: typographySx, ...typographyRest } = typographyProps;
    const typographyComponent = (react_1.default.createElement(Typography_1.default, { ...typographyRest, sx: [styles.tagText, ...(Array.isArray(typographySx) ? typographySx : [typographySx])], variant: size === "small" ? "caption" : "body2", noWrap: true, children: text }));
    return (react_1.default.createElement(Box_1.default, { sx: styles.tagContainer }, tooltipProps ? react_1.default.createElement(Tooltip_1.default, { ...tooltipProps }, typographyComponent) : typographyComponent));
};
exports.default = Tag;
